import { GeoPoint } from "../../earth/core/geoPoint";
import { FrameTime } from "../../earth/earthEngine";
import { EarthEngine } from "../../earth/earthEngine";
import { Country } from "../../earth/model/country";
import { Main } from "../main";
import { UIContext } from "./uiContext";
import { UIContextAttractMode } from "./uiContextAttractMode";

export class UIContextCanTimeout extends UIContext {
    static readonly MaxInactiveTime = 30.0;
    private _inactiveTime: number = 0;
    private _onScreenTouched: number = -1;
    enter(from: UIContext) {
        super.enter(from);
        this._onScreenTouched = EarthEngine.instance.interactionManager.screenTouched.connect(() => { this._inactiveTime = 0; });
    }

    leave(to: UIContext) {
        if (this._onScreenTouched >= 0) {
            EarthEngine.instance.interactionManager.screenTouched.disconnect(this._onScreenTouched);
            this._onScreenTouched = -1;
        }
        super.leave(to);
    }

    update(time: FrameTime) {
        super.update(time);
        this._inactiveTime += time.deltaTime;
        if (this._inactiveTime > UIContextCanTimeout.MaxInactiveTime) {
            this.shouldSwitchToContext.emit(new UIContextAttractMode());
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/uiContextCanTimeout.tsx